import React, { Component } from 'react'
import "./createstudy.css"
import {
  Container,
  Form,
  Button,
  NavLink,
  Spinner
} from 'reactstrap';
import Game from "../../../src/components/Picture/1.JPG";
import Lightbox from "react-image-lightbox";
  


class CreateStudy1 extends Component {
 constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }
  render() {
 const { isOpen } = this.state;
    return (
      
      <div>
        <Container className="comming">
        <Form className="boxstudy">

        <h1 className="textstudy">ช่วงเวลาและวิธีการทางประวัติศาสตร์</h1><br></br>
        
        <img className="photo1" width="853" height="300"
                  onClick={() => this.setState({ isOpen: true })}
                  src={Game}
                  alt="QRcode"
                ></img>
                {isOpen && (
                  <Lightbox
                    mainSrc={Game}
                    onCloseRequest={() => this.setState({ isOpen: false })}
                  />
                )}

        <Form className="b1"><h5 className="textS">แนวคิด</h5>
        
        <h5 className="dd">การศึกษาประวัติศาสตร์ให้ความสำคัญกับเวลา เพราะเวลาเกี่ยวข้องกับการดำเนินชีวิตของมนุษย์อยู่โดยตลอด เวลามีความสำคัญต่อการทำความเข้าใจความสัมพันธ์และการเปลี่ยนแปลงของเรื่องราวที่เกิดขึ้นซึ่งมนุษย์ได้กำหนดช่วงเวลาแตกต่างกันไปตามแนวคิดและความเชื่อของแต่ละสังคม</h5>
        <h5 className="dd">ศักราชหรือช่วงเวลา 1ปีที่ปรากฏมีการใช้กันในสังคมไทยตั้งแต่สมัยอดีตจนถึงสมัยปัจจุบันที่สำคัญ ได้แก่ พุทธศักราช คริสต์ศักราช ฮิจเราะห์ศักราช มหาศักราช จุลศักราช รัตนโกสินทรศก และหากจะกล่าวถึงช่วงเวลาที่ยาวนานมากวว่า 1 ปีก็สามารถระบุเป็นทศวรรษ ศตวรรษ และสหัสวรรษ</h5>
        <h5 className="dd">วิธีการทางประวัติศาตร์เป็นวิธีการที่นักวิชาการทางประวัติศาสตร์ใช้สืบค้าหาความจริงในอดีตอย่างเป็นระบบ เพื่อให้สามารถเข้าใจเหตุการณ์หรือเรื่องราวที่เกิดขึ้นในสังคมมนุษย์</h5>
        </Form>
        
        <Form className="b1"><h5 className="textS">การนับช่วงเวลาและการเทียบศักราช</h5>
        
        <h5 className="dd">ประวัติศาสตร์เป็นการศึกษาเรื่องราวในอดีตที่ผ่านมาแล้วของสังคมมนุษย์ เรื่องราวต่าง ๆ ที่เกิดขึ้นย่อมทีความสีมพันธ์เกี่ยวเนื่องเชื่อมโยงกันตามมิติของเวลา กล่าวคือ เหตุการณ์ที่เกิดขึ้นก่อนย่อมมีผลต่อเหตุการณ์ที่เกิดขึ้นภายหลัง ดังนั้นในการบอกเล่าเรื่องราวทางประวัติศาสตร์จึงต้องสืบค้นว่าเหตุการณ์นั้น ๆ เกิดขึ้นเมื่อใดซึ่งนอกจากจะทำให้เราลำดับเรื่องราวได้ถูกต้องแล้ว เรายังเข้าใจความสัมพันธ์ของเหตุการณ์ต่าง ๆ ว่าเหตุการณ์ใดเป็นเหตุ เหตุการณ์ใดเป็นผล รวมทั้งเข้าใจถึงพัฒนาการความเปลี่ยนแปลงที่เกิดขึ้นตามช่วงเวลาที่ผ่านไป และเพื่อให้เรานำเหตุการณ์ที่เกิดขึ้นจริงในอดีตมาเป็นตัวอย่างหรือบทเรียนในปัจจุบันได้</h5>
        </Form>
         
        <Form className="b1"><h5 className="textS">ช่วงเวลาเกิดจากการสังเกตปรากฏการณ์ธรรมชาติ</h5>
        
        <h5 className="dd">มนุษย์ใช้ประโยชน์จากธรรมชาติเพื่อการดํารงชีวิตมาช้านาน ได้ศึกษาและสังเกต การเปลี่ยนแปลงของธรรมชาติ ทําให้ค้นพบปรากฏการณ์ธรรมชาติที่เกิดขึ้นเป็นประจําทุกปี เช่น การหมุนรอบตัวเองของโลกทําให้เกิดกลางวัน และกลางคืน การโคจรของโลกรอบดวงอาทิตย์ทําให้เกิดฤดูกาลต่างๆ การโคจรของดวงจันทร์รอบโลกทําให้เกิดข้างขึ้น ข้างแรม ปรากฏการณ์ธรรมชาติดังกล่าว ทําให้มนุษย์สามารถแบ่ง ช่วงเวลาออกเป็นวัน เดือน ปี มาตั้งแต่สมัยโบราณ </h5>
        <img className="photo2" width="350" height="300" src="/img/img1/5.JPG" ></img>
        <h5 className="dd"><Spinner color="primary" /> วัน เป็นปรากฏการณ์ที่เกิดจากโลกหมุนรอบตัวเอง ๑ รอบ ทําให้มนุษย์เห็นดวงอาทิตย์ขึ้นเป็นช่วงเวลากลางวัน และดวงอาทิตย์ตกเป็นช่วงเวลากลางคืน และได้กําหนดการหมุน รอบตัวเองของโลก 9 รอบ เป็น ๒๔ ชั่วโมง</h5>
        <h5 className="dd"><Spinner color="success" /> เดือน เป็นปรากฏการณ์ที่เกิดจากดวงจันทร์โคจรรอบโลก 9 รอบ ทําให้มนุษย์ เห็นดวงจันทร์จากเต็มดวงค่อยๆ เว้าแหว่งไปจนมืดมิด จากนั้นจึงค่อยๆ ปรากฏขึ้นอีกจน เต็มดวง ช่วงเวลาการโคจรรอบโลกของดวงจันทร์ 9 รอบ เป็นช่วงเวลาประมาณ ๒๙.๕๓ วัน </h5>
        <h5 className="dd"><Spinner color="info" /> ปี เป็นปรากฏการณ์ที่เกิดจากโลกโคจรรอบดวงอาทิตย์ 9 รอบ มนุษย์สังเกต เห็นว่ามีฤดูกาลต่างๆ หมุนเวียนเปลี่ยนไปเป็นประจําจนครบรอบปี เท่ากับช่วงเวลา ๑๒ เดือน หรือประมาณ ๓๖๕.๒๕ วัน การแบ่งช่วงเวลาที่เกิดจากการสังเกตปรากฏการณ์ธรรมชาติมี ๒ ลักษณะ คือ เวลา ทางจันทรคติ และเวลาทางสุริยคติ </h5><br></br>
        <h5 className="dd"><Spinner type="grow" color="info" /> เวลาทางจันทรคติ เกิดจากการสังเกตการโคจรของดวงจันทร์ เกิดเป็นข้างขึ้น ข้างแรม (เริ่มต้นนับขึ้น ๑ ค่ํา ขึ้น ๒ ค่ําไปจนถึงขึ้น ๑๕ ค่ํา ต่อด้วยแรม ๑ ค่ํา แรม ๒ ค่ําจนถึง แรม ๑๔ ค่ํา หรือแรม ๑๕ ค่ํา รวมเป็น ๑ เดือน) เดือนทางจันทรคติเกิดจากดวงจันทร์หมุน รอบโลก ๑ รอบ เป็นเวลาประมาณ ๒๙ วันครึ่ง ปีทางจันทรคติมี ๑๒ เดือนเท่ากับ ๓๕๔ วัน </h5>
        <h5 className="dd"><Spinner type="grow" color="danger" /> เวลาทางสุริยคติ เกิดจากการสังเกตการโคจรของโลกรอบดวงอาทิตย์ หนึ่งรอบ เท่ากับ ๑ ปี มี ๓๖๔.๒๕ วัน เวลาทางจันทรคติจึงแตกต่างจากเวลาทางสุริยคติ ถึงปีละ ๑๑ วันเศษ ดังนั้นในระบบจันทรคติทุก ๓ ปี จึงมีการเพิ่มเดือนขึ้นอีก ๑ เดือน หลังเดือน ๘ เรียกเดือน ๘ หลัง (เรียกว่า ปีอธิกมาส) และประมาณ ๕ ปี จะมีการเพิ่มวันอีก ๑ วันในเดือน ๗ (เรียกว่า ปีอธิกวาร) เวลาทางจันทรคติจึงตามเวลาทางสุริยคติได้ทัน</h5><br></br>
        <h5 className="dd1">ตัวอย่าง การใช้เวลาทางจันทรคติและสุริยคติ ปัจจุบันการบันทึกเรื่องราว จะใช้เวลาทางสุริยคติเป็นหลัก และนิยมใช้กันทั่วไป เช่น ใน จดหมายเหตุการบูรณปฏิสังขรณ์เสาชิงช้า พุทธศักราช ๒๕๔๙ มีข้อความระบุว่า “เสาชิงช้าสร้างขึ้นในสมัยพระบาทสมเด็จพระพุทธยอดฟ้าจุฬาโลกมหาราช เมื่อวันที่ 4 เมษายน พุทธศักราช ๒๓๒๗ เพื่อประกอบการโล้ชิงช้า ซึ่งเป็นส่วนหนึ่งของพระราชพิธีตรียัมปวาย - ตรีปวาย อันเป็นพระราชพิธีสําคัญพระราชพิธีหนึ่งในพระราชพิธี ๑๒ เดือน...” <br></br>(ที่มา : จดหมายเหตุการบูรณปฏิสังขรณ์เสาชิงช้า, พุทธศักราช ๒๕๔๔, ๒๕๕๑, หน้า ๙.) </h5>
        <h5 className="dd">ในสมัยโบราณการบันทึกเรื่องราวต่างๆ นิยมใช้เวลาทางจันทรคติ เช่น ในเอกสารบันทึก การเดินทางไปฝรั่งเศสของโกษาปาน หรือ พระวิสุทธสุนธร ในสมัยสมเด็จพระนารายณ์มหาราช มีข้อความว่า<br></br> “วัน ๑ ๘ ๘ ค่ำ ขาลอัฏฐศก วันจะรับพระราชสารนั้น เจ้าเมืองแลมูสอนตันตั้ง ข้าหลวง แลกะปิตันนายกําปั้น แลเมศรี หมอผู้ใหญ่ออกกินข้าวเที่ยงด้วยข้าพเจ้า”<br></br>  วัน ๑ ๔ ๘ ค่ำ อ่านว่า วันอาทิตย์ ขึ้น ๔ ค่ํา เดือน ๘ ซึ่งตรงกับวันที่ ๒๐ มิถุนายน พุทธศักราช ๒๒๒๙ <br></br>(ที่มา : ประวัติโกษาปานและบันทึกการเดินทางไปฝรั่งเศส, ๒๕๓๐, หน้า ๓๓.)</h5>
        </Form>
          <p h5 align='center'><Button  href='/study' outline color="warning" >ย้อนกลับ</Button>{' '}</p>
          <p h5 align='center'><Button href='/createStudy2' outline color="primary" >บทถัดไป</Button>{' '}</p>
        
        </Form>
        </Container>

        <div className="footer text-footer">
          <p>Surasak   Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>           
          <NavLink href="https://surasak783023869.wordpress.com/">ช่องทางการติดต่อ</NavLink>
        </div>

      </div>
    )
  }
}

export default CreateStudy1